import { Badge, Button, Card, CloseButton, Group, Image, Kbd, Text } from "@mantine/core";
import classes from './ApplicationTip.module.scss';

const image = 'assets/images/tips/001.jpg';

const ApplicationTip = ({onClose}) => {

    const onTipClose = () => {
        onClose();
    }
    
    return (
        <Group style={{position:'absolute', bottom:15, zIndex:99, left:15, right:15,alignContent:'flex-end', justifyContent:'end'}}>

            <Card withBorder className={classes.card}>
                <CloseButton className={classes.closeButton} onClick={() => onTipClose()} />
                <Card.Section>
                    <Image src={image} alt={'title'} height={100} />
                </Card.Section>

                <Group justify="left" mt="xl">
                    <Badge size='xs' variant="gradient" gradient={{ from: '#ed6ea0', to: '#ec8c69', deg: 35 }} >Hot Tip</Badge>
                    <Text size="sm" fw={700} className={classes.title}>
                     Adding Annotations
                    </Text>
                    <Group gap={5}>
                    {/* <Text size="xs" color="dimmed">
                        80% completed
                    </Text> */}
                    
                    </Group>
                </Group>
                <Text mt="sm" mb="md" color="dimmed" size="xs">
                    When in selection mode Hold <Kbd>shift</Kbd> to draw an annotation quickly
                </Text>

                <Button variant="default" fullWidth onClick={() => onTipClose()}>Ok got it!</Button>
                {/* <Card.Section className={classes.footer}>section here</Card.Section> */}
                </Card>


        {/* <Notification sx={{opacity:.8}} icon={<IconInfoCircle size={18} />} color="green" onClose={() => onTipClose()}>
            
        </Notification> */}
        </Group>
    )
}

export default ApplicationTip;


export const TipTypes = {
    APPROVAL:'approvalTips',
  }